import React, { useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import gsap from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
import erpHero from "../assets/Hero/Business-Central-Benefits.jpg"; // Replace with your hero image
import erpImage from "../assets/Hero/Business-Central.jpg"; // Replace with your ERP image
import "../assets/css/erpSolutionsPage.css";

// Register the ScrollTrigger plugin
gsap.registerPlugin(ScrollTrigger);

// JSON data for headings and paragraphs
const erpData = {
  hero: {
    title: "ERP Solutions",
    subtitle: "Streamline Your Business Operations with Advanced ERP Systems",
  },
  introduction: {
    heading: "Why ERP Solutions Matter",
    paragraphs: [
      "Enterprise Resource Planning (ERP) systems integrate core business processes, providing real-time visibility and control over operations.",
      "Our ERP solutions are designed to enhance efficiency, improve decision-making, and drive growth for your business.",
    ],
  },
  cta: {
    heading: "Ready to Transform Your Business?",
    text: "Contact us today to learn more about our ERP Solutions and how we can help your business thrive.",
  },
};

export const ERPSolutionsPage = ({ data }) => {
  const erpRef = useRef(null);
  const navigate = useNavigate(); // Initialize useNavigate

  useEffect(() => {
    const elements = erpRef.current.querySelectorAll(".erp-animate");

    gsap.fromTo(
      elements,
      { y: 100, opacity: 0 },
      {
        y: 0,
        opacity: 1,
        duration: 1.0,
        ease: "power3.out",
        stagger: 0.2,
        scrollTrigger: {
          trigger: erpRef.current,
          start: "top 80%",
          toggleActions: "play none none reset",
        },
      }
    );
  }, []);

  // Function to handle navigation
  const handleContactClick = () => {
    navigate("/contact"); // Navigate to the contact page
  };

  return (
    <div id="erp-page" ref={erpRef}>
      {/* Hero Section */}
      <div
        className="erp-hero-section"
        style={{ backgroundImage: `url(${erpHero})` }}
      >
        <h1 className="erp-animate">{erpData.hero.title}</h1>
        <p className="erp-animate">{erpData.hero.subtitle}</p>
      </div>

      {/* Introduction Section */}
      <div className="container erp-introduction">
        <div className="row">
          <div className="col-md-6">
            <h2 className="erp-animate">{erpData.introduction.heading}</h2>
            {erpData.introduction.paragraphs.map((paragraph, index) => (
              <p key={index} className="erp-animate">
                {paragraph}
              </p>
            ))}
          </div>
          <div className="col-md-6 erp-image-container">
            <img
              src={erpImage}
              className="img-fluid erp-animate"
              alt="ERP Solutions"
            />
          </div>
        </div>
      </div>

      {/* Call to Action Section */}
      {/* <div className="container erp-cta">
        <h2 className="erp-animate">{erpData.cta.heading}</h2>
        <p className="erp-animate">{erpData.cta.text}</p>
        <button
          className="btn btn-primary erp-animate"
          onClick={handleContactClick} // Add onClick handler
        >
          Contact Us
        </button>
      </div> */}
    </div>
  );
};